import { render, staticRenderFns } from "./CommunityCard.vue?vue&type=template&id=fd3f05ba&"
import script from "./CommunityCard.vue?vue&type=script&lang=js&"
export * from "./CommunityCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/users/averton/apps/averton/web/app/themes/averton-1865/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd3f05ba')) {
      api.createRecord('fd3f05ba', component.options)
    } else {
      api.reload('fd3f05ba', component.options)
    }
    module.hot.accept("./CommunityCard.vue?vue&type=template&id=fd3f05ba&", function () {
      api.rerender('fd3f05ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/src/js/vue/CommunityCard.vue"
export default component.exports